// extracted by mini-css-extract-plugin
module.exports = {"bodyArea":"MapHistoryController_bodyArea__lis1N","btn":"MapHistoryController_btn__1XNtJ","slideArea":"MapHistoryController_slideArea__25uxy"};